import { render, staticRenderFns } from "./iot.vue?vue&type=template&id=72bbbf1b&"
import script from "./iot.vue?vue&type=script&lang=js&"
export * from "./iot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports